export const TABLE_COLUMN_WIDTHS = {
  tcActions: {
    minWidth: 120,
  },
  tcTitle: {
    width: '20%',
    minWidth: 120,
    wordBreak: 'break-word' as const,
  },
  tcNoOfMonths: {
    minWidth: 130,
  },
  tcCategory: {
    minWidth: 170,
  },
  tcDate: {
    width: '20%',
    minWidth: 120,
  },
  tcAmount: {
    width: '15%',
    minWidth: 120,
  },
};

export const STATE_NAME = 'paymentPlan';
export const LISTING_PHOTO_SIZE = '450x';
export const ALERT_INTERVAL = 3000;
